module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('aside', {
    staticClass: "control-sidebar control-sidebar-light"
  }, [_c('ul', {
    staticClass: "nav navbar-stacked "
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Black-100 bg ti-menu-alt"
  }), _vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Deep-Purple-100 bg ti-menu-alt"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Deep-Purple-200 bg ti-shopping-cart-full"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Deep-Purple-400 bg ti-gift"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Deep-Purple-600 bg ti-truck"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Deep-Purple-800 bg ti-home"
  }), _vm._v("Shipping proses of "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!"), _c('small', [_vm._v("1m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Blue-A100 bg ti-user"
  }), _vm._v("Meet new user "), _c('strong', [_vm._v("Lilian Meirs")]), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Red-A400 bg ti-cloud-down"
  }), _c('strong', [_vm._v("Robert")]), _vm._v(" added new request for ne item for refund"), _c('small', [_vm._v("34m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Orange-200 bg ti-menu-alt"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Orange-400 bg ti-shopping-cart-full"
  }), _c('i', {
    staticClass: "ti-more-alt"
  }), _c('span', {
    staticClass: "palette-Orange-600 bg ti-gift"
  }), _c('br'), _vm._v("Shipping proses of "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!"), _c('small', [_vm._v("40m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Amber-500 bg ti-comment-alt"
  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("50m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item "), _c('small', [_vm._v("1h")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Light-Green-500 bg ti-image"
  }), _c('strong', [_vm._v("Lilian Meirs")]), _vm._v(" Posting new image cover, and just got 2.000 likes"), _c('br'), _c('img', {
    attrs: {
      "alt": "",
      "src": "https://source.unsplash.com/category/technology/500x200"
    }
  }), _c('small', [_vm._v("1h 12m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Amber-500 bg ti-comment-alt"
  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("1h 39")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item"), _c('br'), _c('img', {
    attrs: {
      "alt": "",
      "src": "https://source.unsplash.com/category/food/500x200"
    }
  }), _vm._v(" "), _c('small', [_vm._v("1h 45m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
  }), _vm._v("Amazing! "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item "), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "palette-Amber-500 bg ti-comment-alt"
  }), _vm._v("Mike Nilson commented Post"), _c('br'), _vm._v("\nLike this one! Keep going!"), _c('small', [_vm._v("2h")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7669d7e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/ControlSidebar.vue
// module id = 461
// module chunks = 2